import { SagaIterator } from 'redux-saga';
import { put, call, takeLatest, StrictEffect, select } from 'redux-saga/effects';

import { fetchSiteSuccess, fetchSite, fetchSiteError, updateSiteNewIssues, selectedSiteSuccess, selectedSiteError, selectedSite } from './index';
import { apiInstance } from 'src/services/interceptor';
import { PayloadAction } from '@reduxjs/toolkit';

interface PayloadProps {
  user?: string | null;
  id?: string | null;
}

function* getSite({ payload }: PayloadAction<PayloadProps>): SagaIterator {
  try {
    const user = yield select((state) => state.user.data);
    const response = yield call(apiInstance, `tenant/${user.tenantId}/sites/${payload.id}`);
    yield put(fetchSiteSuccess(response.data));
  } catch (e) {
    yield put(fetchSiteError());
  }
}

function* updateSiteNewIssuesSaga({ payload }: PayloadAction<PayloadProps>): SagaIterator {
  try {
    yield call(apiInstance.put, `/issues/visited/${payload.id}`, { userIssuesNew: 0 });
  } catch (e) {
    yield put(fetchSiteError());
  }
}

function* setSelectedSiteSaga({payload} : any): Generator<StrictEffect, void> {
    const site = payload.selectedSiteData
    if ( site ) {
      yield put(selectedSiteSuccess(site));
    }
    yield put(selectedSiteError(site));
}

function* siteSaga(): Generator<StrictEffect, void> {
  yield takeLatest(fetchSite.type, getSite);
  yield takeLatest(updateSiteNewIssues.type, updateSiteNewIssuesSaga);
  yield takeLatest(updateSiteNewIssues.type, updateSiteNewIssuesSaga);
  yield takeLatest(selectedSite.type, setSelectedSiteSaga);
}

export { siteSaga };
